/**
 * @generated SignedSource<<295536bf2961ffefafd49624567bbd9e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PolicyExemption = "IGNORE_LOCKDOWN" | "IGNORE_PIN" | "TOLERATE_WINDOWED";
import { FragmentRefs } from "relay-runtime";
export type accommodations_accommodation$data = {
  readonly id: string;
  readonly newStartTime: string | null;
  readonly percentTimeExpansion: number;
  readonly policyExemptions: ReadonlyArray<PolicyExemption> | null;
  readonly registration: {
    readonly id: string;
    readonly user: {
      readonly displayName: string;
    };
  };
  readonly " $fragmentType": "accommodations_accommodation";
};
export type accommodations_accommodation$key = {
  readonly " $data"?: accommodations_accommodation$data;
  readonly " $fragmentSpreads": FragmentRefs<"accommodations_accommodation">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "accommodations_accommodation",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "newStartTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "percentTimeExpansion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "policyExemptions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Registration",
      "kind": "LinkedField",
      "name": "registration",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Accommodation",
  "abstractKey": null
};
})();

(node as any).hash = "a4a8c626346ee5850f59d075b33e031c";

export default node;
